import React, { Fragment } from 'react';
import { BadgeCheck, MapPin, Users, Truck, Building2 } from 'lucide-react';
export function TrustStrip() {
  const items = [{
    icon: BadgeCheck,
    text: 'Licensed & Insured'
  }, {
    icon: Users,
    text: 'Experienced Professional Crews'
  }, {
    icon: MapPin,
    text: 'Nationwide Operations'
  }, {
    icon: Truck,
    text: 'Reliable Logistics'
  }, {
    icon: Building2,
    text: 'Residential & Commercial'
  }];
  return <div className="bg-navy border-b border-gold/20 py-8" data-id="element-232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4" data-id="element-234">
          {items.map((item, index) => <Fragment key={index} data-id="element-235">
              <div className="flex items-center gap-3 text-white/90 group" data-id="element-236">
                <item.icon className="w-5 h-5 text-gold group-hover:scale-110 transition-transform" data-id="element-237" />
                <span className="text-sm font-medium tracking-wide" data-id="element-238">
                  {item.text}
                </span>
              </div>
              {index < items.length - 1 && <div className="hidden md:block w-px h-8 bg-gold/30" data-id="element-239" />}
            </Fragment>)}
        </div>
      </div>
    </div>;
}